import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import PropTypes from 'prop-types';

const barDefault = {
  xAxisProps: {
    dataKey: 'name',
    textAnchor: 'end',
    verticalAnchor: 'end',
    scaleToFit: false,
    interval: 0,
    fontSize: '10px',
    // scale: 'auto',
  },
  yAxisProps: {
    fontSize: '10px',
  },
};

// const data = [
//   {
//     name: 'Jan',
//     2019: 4000,
//     2020: 2400,
//   },
//   {
//     name: 'Feb',
//     2019: 3000,
//     2020: 1398,
//   },
//   {
//     name: 'Mar',
//     2019: 2000,
//     2020: 9800,
//   },
//   {
//     name: 'Apr',
//     2019: 2780,
//     2020: 3908,
//   },
//   {
//     name: 'May',
//     2019: 1890,
//     2020: 4800,
//   },
//   {
//     name: 'Jun',
//     2019: 2390,
//     2020: 3800,
//   },
//   {
//     name: 'Jul',
//     2019: 3490,
//     2020: 4300,
//   },
//   {
//     name: 'Aug',
//     2019: 3490,
//     2020: 4300,
//   },
//   {
//     name: 'Sep',
//     2019: 3490,
//     2020: 2000,
//   },
//   {
//     name: 'Oct',
//     2019: 3490,
//     2020: 4300,
//   },
//   {
//     name: 'Nov',
//     2019: 3490,
//     2020: 4300,
//   },
//   {
//     name: 'Dec',
//     2019: 3490,
//     2020: 4300,
//   },
// ];

function EwalletChartComponent({
  chartData,
}) {
  return (
    <ResponsiveContainer width="100%" height={400}>
      <AreaChart
        data={chartData}
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0,
        }}
      >
        <defs>
          <linearGradient id="color1" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#A3B3F9" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#A3B3F9" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="color2" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#B1CDF8" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#B1CDF8" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="color3" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#BBE9FE" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#BBE9FE" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="color4" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#5272AA" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#5272AA" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="color5" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#84DAFF" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#84DAFF" stopOpacity={0} />
          </linearGradient>

        </defs>
        <CartesianGrid height={1} y={0} />
        <XAxis {...barDefault.xAxisProps} dataKey="name" />
        <YAxis axisLine={false} tick={false} />
        <Tooltip />
        {/* BILLS_PAYMENT */}
        <Area
          type="monotone"
          dataKey="BILLS_PAYMENT"
          stackId="1"
          stroke="#A3B3F9"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#color1)"
        />
        {/* CASH_IN */}
        <Area
          type="monotone"
          dataKey="CASH_IN"
          stackId="2"
          stroke="#B1CDF8"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#color2)"
        />
        {/* CASH_TRANSFER */}
        <Area
          type="monotone"
          dataKey="CASH_TRANSFER"
          stackId="3"
          stroke="#BBE9FE"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#color3)"
        />
        {/* MOBILE_LOAD */}
        <Area
          type="monotone"
          dataKey="MOBILE_LOAD"
          stackId="4"
          stroke="#5272AA"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#color4)"
        />
        {/* RECEIVE_CASH */}
        <Area
          type="monotone"
          dataKey="RECEIVE_CASH"
          stackId="5"
          stroke="#84DAFF"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#color5)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}

EwalletChartComponent.propTypes = {
  chartData: PropTypes.instanceOf(Array).isRequired,
};

export default EwalletChartComponent;
